<template>
  <grid flat direction="stack">
    <grid-item>
      <h2 class="heading heading--lg heading--underlined">Articles</h2>
    </grid-item>
    <grid-item>
      <div class="dev-hub__separator-blog"></div>
      <ArticlesList
        :list-component="component"
        :options="{}"
        :articles="articles"
      />
    </grid-item>
  </grid>
</template>

<script>
import ArticlesList from "@/components/common/ArticlesList";
import Item from "@/components/UpdatesItem";

import { ArticleResource } from "@/services";

export default {
  components: {
    ArticlesList
  },
  data() {
    return {
      component: Item,
      articles: []
    };
  },
  methods: {
    async loadArticles() {
      const response = await ArticleResource.get(
        Object.assign({}, this.options)
      );
      this.articles = response.body.rows;
      this.totalCount = response.body.count;
    }
  },
  created() {
    this.loadArticles();
  }
};
</script>
